import { BaseJsBridge } from './BaseJsBridge';
import { insertScript, getURLSearchParams } from '@/sdk/vrAppJsSdk/utils';

let yc;

class AppJsBridge extends BaseJsBridge {
  constructor() {
    super('app');
  }

  async init(config) {
    config = {
      sdkUrl:
        'https://onewo-space-public-pro.obs.cn-south-1.myhuaweicloud.com/js/onewo-js-bridge/JSBridge.1.1.0.js',
      ...config,
    };
    try {
      await insertScript('iCloudCitySdkScript', config.sdkUrl);
    } catch (e) {
      return Promise.reject(this.fail({ msg: 'App SDK加载失败' }));
    }

    // yc = window.yc;
    const jsbridge = new JSBridge();
    window.yc = jsbridge;
    yc = jsbridge;

    this.initialized = true;

    return Promise.resolve(this.success({ msg: 'SDK初始化成功' }));
  }

  /**
   * 扫码和识别本地二维码
   * @returns {Promise<unknown>}
   */
  async scanQRCode() {
    return new Promise((resolve, reject) => {
      yc.scanQRCode(resString => {
        const res = JSON.parse(resString);
        if (res.code === 0) {
          resolve(res);
        } else {
          reject(res);
        }
      });
    });
  }

  /**
   * 获取子服务accessToken
   * @param {Object} getTokenParams - 请求参数信息
   *  - @param {String} getTokenParams.url - 请求接口地址
   *  - @param {Object} getTokenParams.params - 获取token的参数（除code、appId外的其他参数）
   *  - @param {String} getTokenParams.method - 请求方法 默认POST
   *  - @param {String} getTokenParams.headers - 请求头
   * @returns {Promise<unknown>}
   */
  async getServiceAccessToken(getTokenParams = {}) {
    if (!getTokenParams?.url) {
      return Promise.reject(this.fail({ msg: '获取accessToken异常，缺少参数url' }));
    }
    const { params = {} } = getTokenParams;
    const urlParams = getURLSearchParams(window.location.href);
    const { code, appId, phone } = urlParams;
    const requestParams = {
      code,
      //appId: appId || channelId, // 因为子服务的环境变量里面配置appId会使子服务多一个层级，所以环境变量中改用channelId字段
      loginForm: 'app',
      phone,
      ...params,
    };
    if (appId ) {
      requestParams.appId = appId;
    }
    if (!requestParams.code)
      return Promise.reject(this.fail({ msg: '获取accessToken异常，缺少参数 code' }));
    return this.sdkAjax({ ...getTokenParams, params: requestParams });
  }

  /**
   * 获取子服务用户信息
   * @param {Object} getUserInfoParams - 请求参数信息
   *  - @param {String} getUserInfoParams.url - 请求接口地址
   *  - @param {Object} getUserInfoParams.params - 获取用户信息的参数
   *  - @param {String} getUserInfoParams.method - 请求方法 默认POST
   *  - @param {String} getUserInfoParams.headers - 请求头
   * @returns {Promise<unknown>}
   */
  async getServiceUserInfo(getUserInfoParams = {}) {
    if (!getUserInfoParams?.url) {
      return Promise.reject(this.fail({ msg: '获取用户信息异常，缺少参数url' }));
    }
    return this.sdkAjax({ ...getUserInfoParams });
  }
}

export { AppJsBridge };
